import * as React from 'react';
import { Routes, Route } from "react-router-dom";
import { AjadiProvider } from './Components/Context/AjadiContext';
import HomePage from './Components/HomePage';
import AjadiApp from './Components/AjadiApp';
import { DataExporter } from './Components/DataExporter';
import { Questionnaire } from './Components/Questionnaire';


const App = () => {
  return  (
  <>
    <AjadiProvider>
    <Routes>
          <Route index element={<HomePage />} />
          <Route path="ajadi" element={<AjadiApp />} />
           <Route path="export" element={<DataExporter />} />
           <Route path="questionnaire" element={<Questionnaire />} />
      </Routes>
    </AjadiProvider>
  </>
  )
}

export default App
